<template>
    <v-flex xs12>
        <div class="listfiles">
            <div v-for="(file, index) in files" :key="index" >
                <div class="fileitem">
                <div class="filename">
                    <span class="fileiconecontainer">
                    <span class="icon-file-filled"></span>
                </span>
                <span class="filenamecontainer">
                    {{ file.name }}
                    <span class="smalltext greytext"> {{title}} </span>
                </span>

                </div>
                <div class="action">
                        <span v-on:click="readFile(file.name)" class="icon-download imgactionfile right"></span>
                </div>
                </div>
            </div>
        </div>
    </v-flex>
</template>
<script>
export default {
  props: ['files', 'title'],
  methods: {
    readFile (key) {
      var file = this.files.find(c => c.name === key)
      if (file) {
        var reader = new FileReader()
        reader.onload = function () {
          let a = document.createElement('a')
          a.href = reader.result
          a.download = file.name
          a.click()
        }
        reader.readAsDataURL(file)
      }
    }
  }
}
</script>
<style scoped>
.fileiconecontainer{
  padding-top: 7px;
  width: 20%;
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(212, 217, 225, 1.0);
  padding-left: 6px;
  height: 40px;
  max-width: 37px;
}

.fileitemseparator{
  padding-top: 13px;
}

.filenamecontainer {
  padding-left: 9px;
  padding-top: 3px;
  width: 80%;
}

.filename {
  display: inline-flex;
  width: 70%;
}
.listfiles{
  padding-bottom:21px;
  padding-top: 10px;
}
.fileitem {
  display: inline-flex;
  width: 100%;
  padding-top: 16px;
}
</style>
